var map = {
	"./additional-resources.de-CH.json": 1422,
	"./additional-resources.de-DE.json": 1423,
	"./additional-resources.en-CA.json": 1424,
	"./additional-resources.en-GB.json": 1425,
	"./additional-resources.en-IN.json": 1426,
	"./additional-resources.en-ME.json": 1427,
	"./additional-resources.en-US.json": 1428,
	"./additional-resources.es-EM.json": 1429,
	"./additional-resources.es-ES.json": 1430,
	"./additional-resources.fr-BE.json": 1431,
	"./additional-resources.fr-CA.json": 1432,
	"./additional-resources.fr-CH.json": 1433,
	"./additional-resources.nl-BE.json": 1434,
	"./additional-resources.nl-NL.json": 1435,
	"./additional-resources.pl-PL.json": 1436,
	"./additional-resources.pt-BR.json": 1437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1421;